// src/utils/gtm.js
import TagManager from 'react-gtm-module';

export const pushGTMEvent = ({ event, category, action, label }: any) => {
  TagManager.dataLayer({
    dataLayer: {
      event,
      category,
      action,
      label,
    },
  });
};
